import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom';
import { FiLogOut } from "react-icons/fi";
import { GiCombinationLock } from "react-icons/gi";
import { AppContext } from '../../../Contexts/App/AppContext';
import service from '../../../Contexts/App/AppService';
import SettingsIcon from '../../../Svgs/SettingsIcon';
import '../styles/avatarDropdown.scss'
function DropDownOptions(props) {
  const appCtx = useContext(AppContext);
  const history = useHistory();
  return (
    <div>
      <MenuItem onClick={props.hide}>
        <Link to="/settings">
          <SettingsIcon fill={'#000'} className="dropdown-internal-icon-settings" />
          <span style={{ paddingTop: 3, color: "#000" }}>Settings</span>
        </Link>
      </MenuItem>
      <MenuItem onClick={() => {
        service.SetUserLogOut(appCtx, res => {
          localStorage.removeItem('LocationID');
          localStorage.removeItem('ParentID');
          localStorage.removeItem('ProjectID');
          localStorage.removeItem('subActivity');
          localStorage.removeItem('parking-lot-filter-orderItems');
          localStorage.removeItem('filter-orderItems');
          history.push('/login');
        });
        props.hide()
      }}>

        <Link  >
          <FiLogOut className="dropdown-internal-icon" style={{ color: "#000", position: 'relative', top: '2px' }} />
          <span style={{ color: "#000" }} >Logout</span>
        </Link>
      </MenuItem>
    </div>
  );
}

export default DropDownOptions;